import styled from "@emotion/styled";

export const Wrapper = styled.div`
  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    display: flex;
    align-items: center;
  }
`;

export const InputWrapper = styled.div`
  flex-grow: 1;
`;

export const ButtonWrapper = styled.div`
  min-width: 127px;

  margin-top: ${p => p.theme.space[4]}px;

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    margin-left: ${p => p.theme.space[4]}px;
    margin-top: ${p => p.theme.space[0]};
  }
`;

export const TableWrapper = styled.div`
  margin-top: ${p => p.theme.space[6]}px;
`;
